/* eslint-disable react/react-in-jsx-scope */
import { useAuth } from "../../contexts/session_context";
import { useRouter } from 'next/router'
import { Loading } from "../../page-components/shared/Loading";
import { useEffect } from 'react';
export default function Home() {
  const router = useRouter();
  const { loading, isIntegratorAuthenticated, currentSiteSelection, app_configuration, increment_page, pageOffset } = useAuth();
  
  useEffect(() => {
    if (app_configuration && !loading) {
      if (pageOffset) {
        router.push(increment_page(pageOffset));
      } else {
        router.push(increment_page(0));
      }
    }
  }, [loading, isIntegratorAuthenticated, currentSiteSelection, app_configuration, pageOffset]);

  return (
    <Loading />
  );
}
